import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import * as refValSheetActions from './reference-value-sheet.actions';
import * as performanceActions from '../../performance/store/actions/performance.actions';
import {
  ReferenceValueSheet,
  ReferenceValueSheetDataSeries,
  RefValSheetModuleState,
} from '../models/reference-value-sheet.model';

function selectIdNumber(c: ReferenceValueSheet): number {
  return c.id;
}

export const adapter: EntityAdapter<ReferenceValueSheet> = createEntityAdapter<ReferenceValueSheet>(
  {
    selectId: selectIdNumber,
  },
);

export const initialState = <RefValSheetModuleState>{
  refValSheets: adapter.getInitialState([]),
  isLoaded: false,
  columns: [],
  refValSheetDataSeries: undefined,
  refValSheetKPIResults: undefined,
};
const ReferenceValueSheetReducer = createReducer(
  initialState,
  on(refValSheetActions.clearRefValSheetState, (state) => ({
    ...state,
    isLoaded: false,
    refValSheets: adapter.removeAll(state.refValSheets),
  })),
  on(refValSheetActions.loadRefValSheetsSuccess, (state, { refValSheets }) => ({
    ...state,
    isLoaded: true,
    refValSheets: adapter.setAll(refValSheets, state.refValSheets),
  })),
  on(refValSheetActions.loadRefValSheetDataSeriesSuccess, (state, { refValSheetDataSeries }) => ({
    ...state,
    refValSheetDataSeries,
  })),
  on(refValSheetActions.loadRefValSheetKPIsSuccess, (state, { refValSheetKPIResults }) => ({
    ...state,
    refValSheetKPIResults,
  })),
  on(refValSheetActions.upsertRefValSheetSuccess, (state, { refValSheet }) => ({
    ...state,
    refValSheets: adapter.upsertOne(refValSheet, state.refValSheets),
  })),
  on(refValSheetActions.deleteRefValSheetSuccess, (state, { refValSheetId }) => ({
    ...state,
    refValSheets: adapter.removeOne(refValSheetId, state.refValSheets),
  })),
  on(refValSheetActions.setColumnSettings, (state, { value }) => ({
    ...state,
    columns: value,
    isLoaded: true,
  })),
  on(performanceActions.setSelectedCycleId, (state) => ({
    ...state,
    refValSheetDataSeries: undefined as ReferenceValueSheetDataSeries[],
  })),
);

export function reducer(state: RefValSheetModuleState | undefined, action: Action) {
  return ReferenceValueSheetReducer(state, action);
}
